import React, { useContext, useState } from "react";
import { useHistory, useLocation } from "react-router";

// https://codesandbox.io/s/checkout-j619p?file=/src/components/section-summary/index.js
import CartContext from "../../../context/CartContext";

const Checkout = () => {
  let history = useHistory();
  const handleFormSubmit = (e) => {
    e.preventDefault();
    localStorage.clear();
    history.push("/");
    alert("Purchase Completed");
    window.location.reload(false);
  };
  const { showCart, cartItems, showHideCart, removeItem, total, itemCount } =
    useContext(CartContext);
  console.log("CLG checkoput page", cartItems);
  return (
    <div className="checkout-page">
      <div className="checkout-title">
        <h1>CHECKOUT</h1>
      </div>

      <div className="checkout-box-container">
        <div className="left-checkout">
          <h4>Shipment Details</h4>
          <form className="form">
            <div className="form-inputs">
              <label className="form-label">Full Name</label>
              <input
                className="form-input"
                type="text"
                name="firstName"
                placeholder="Enter your first name"
                required
              />
              {/* <label className="form-label">Last Name</label>
              <input
                className="form-input"
                type="text"
                name="lastName"
                placeholder="Enter your last name"
                required
              /> */}
            </div>

            <div className="form-inputs">
              <label className="form-label">Address</label>
              <input
                className="form-input"
                type="text"
                name="address"
                placeholder="Address"
                required
              />
            </div>
            <div className="form-inputs">
              <label className="form-label">City</label>
              <input
                className="form-input"
                type="text"
                name="city"
                placeholder="City"
              />
              <label className="form-label">State</label>
              <input
                className="form-input"
                type="text"
                name="state"
                placeholder="state"
              />
              <label className="form-label">Zipcode</label>
              <input
                className="form-input"
                type="text"
                name="zipcode"
                placeholder="zipcode"
              />
            </div>
            <div className="form-inputs">
              <label className="form-label ti-credit-card"> Credit Card</label>
              <input
                className="form-input"
                type="text"
                name="creditcard"
                placeholder="Credit Card"
                maxlength="19"
                value="4242424242424242"
              />
              <label className="form-label">Expiration</label>
              <input
                className="form-input"
                type="text"
                name="mmyy"
                placeholder="MM / YY"
                maxlength="7"
                value="08/21"
              />

              <label className="form-label">CVC</label>
              <input
                className="form-input"
                type="text"
                name="cvc"
                placeholder="cvc"
                maxlength="3"
                value="123"
              />
            </div>
            <button
              className="custom-button btn-3"
              type="submit"
              onClick={handleFormSubmit}
            >
              <span>Place Order</span>
            </button>
          </form>
        </div>
        {/*  */}
        {/* right */}
        <div className="right-summary">
          <div className="column">
            <h4>Purchase Summary</h4>
          </div>
          <hr />
          <div className="checkoutOrderSummary">
            <div className="row-container">
              <div className="row">
                <div className="subtotal-left">
                  <span>Subtotal ({itemCount}) </span>
                </div>
                <div className="subtotal-right">
                  <span>{total}</span>
                </div>
              </div>
              <div className="row">
                <div className="column">
                  <span>Estimated Shipping: </span>
                </div>
                <div className="columnRight">
                  <span>Free</span>
                </div>
              </div>

              {/* tax */}
              <div className="row">
                <div className="column">
                  <span>Tax: </span>
                </div>
                <div className="columnRight">
                  <span>TBD</span>
                </div>
              </div>
              <hr />
              {/* eof tax */}
              {/* Divider */}
              <div className="row">
                <div className="column">Total:</div>
                <div className="columnRight">
                  <span>${total}</span>
                </div>
              </div>
            </div>
            <div className="checkout-cart-details">
              <div className="cart-container">
                <h4>Your Cart:</h4>
                <div className="cart-items">
                  {cartItems.map((item, index) => (
                    <div className="item" key={index}>
                      {/* <span>{item.title}</span> */}
                      <img src={item.image_url} />
                      <div className="item-price">
                        <span>${item.price.toFixed(2)}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
